export default __webpack_public_path__ + "static/media/closet5-before1-1920w.3e9dadc8.avif";